<mat-toolbar class="nav">
  <a routerLink="/" class="brand">
    <span class="brand-mark">S</span>
    <span class="brand-text">
      <strong>Seamus Services</strong>
      <small>North Beach</small>
    </span>
  </a>

  <span class="spacer"></span>

  <nav class="links">
    <a mat-button routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">Home</a>
    <a mat-button routerLink="/book" routerLinkActive="active">Book</a>
    @if (auth.isLoggedIn()) {
      <a mat-button routerLink="/my-bookings" routerLinkActive="active">My Bookings</a>
    }
    @if (auth.isOwner()) {
      <a mat-button routerLink="/owner" routerLinkActive="active">Owner</a>
    }
  </nav>

  @if (auth.isOwner()) {
    <button
      mat-icon-button
      [matMenuTriggerFor]="alertMenu"
      [matBadge]="notifications.unreadCount() || null"
      matBadgeColor="warn"
      matBadgeSize="small"
      aria-label="Notifications"
      (menuOpened)="markAllRead()"
    >
      <mat-icon>notifications</mat-icon>
    </button>
    <mat-menu #alertMenu="matMenu" class="alert-menu">
      @for (n of notifications.notifications(); track n.id) {
        <button mat-menu-item>
          <mat-icon>event_available</mat-icon>
          <span>{{ n.message }}</span>
        </button>
      } @empty {
        <button mat-menu-item disabled>No alerts yet</button>
      }
    </mat-menu>
  }

  @if (auth.isLoggedIn()) {
    <button
      mat-button
      class="auth-cta"
      [matMenuTriggerFor]="accountMenu"
      [attr.aria-label]="displayName()"
    >
      <mat-icon class="account-icon">account_circle</mat-icon>
      <span class="account-initials" aria-hidden="true">{{ initials() }}</span>
      <span class="account-label">{{ displayName() }}</span>
    </button>
    <mat-menu #accountMenu="matMenu">
      <div class="menu-caption" mat-menu-item disabled>
        {{ auth.isOwner() ? 'Owner account' : 'Neighbor account' }}
      </div>
      <mat-divider></mat-divider>
      <a mat-menu-item routerLink="/book">
        <mat-icon>event</mat-icon>
        Book a service
      </a>
      <a mat-menu-item routerLink="/my-bookings">
        <mat-icon>list_alt</mat-icon>
        My bookings
      </a>
      @if (auth.isOwner()) {
        <a mat-menu-item routerLink="/owner">
          <mat-icon>admin_panel_settings</mat-icon>
          Owner dashboard
        </a>
      }
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="logout()">
        <mat-icon>logout</mat-icon>
        Sign out
      </button>
    </mat-menu>
  } @else {
    <a mat-stroked-button class="auth-cta" routerLink="/login">
      <mat-icon>login</mat-icon>
      Sign in
    </a>
  }
</mat-toolbar>
